import { Outlet, useLocation } from "react-router";
import { ProgramasGestionPage } from "@/features/programas";

export default function GestionProgramas() {
  const location = useLocation();
  const isDetalles = location.pathname.includes("gestion-programas/detalles");

  if (isDetalles) {
    return <Outlet />;
  }

  return <ProgramasGestionPage scope="owned" />;
}
